import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $CardContentThumbnailWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding: ${spacing('xs')} ${spacing('sm')};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.tw.radius.sm};
  margin-right: ${spacing('lg')};
  max-width: ${spacing(10)};
  flex: 0 0 40px;
  height: ${spacing(10)};
  overflow: hidden;
`;

export const $CardContentThumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  && svg {
    max-width: ${spacing(9)};
    max-height: ${spacing(9)};
  }

  && img {
    object-fit: contain;
    max-height: ${spacing(16)};
    max-width: ${spacing(16)};
  }
`;

export const $CardContentDescription = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  min-width: 0;
`;

export const $CardContentProductName = styled.div`
  color: ${({ theme }) => theme.colors.mainTextColor};
`;

export const $CardContentSerialNumber = styled.div`
  color: ${({ theme }) => theme.colors.tertiary};
  span {
    display: block;
  }

  & > span > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const $CardContentContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 100%;
`;
